import React from "react";
import { useNavigate } from "react-router-dom";

interface CardProps {
  id: string | number;
  image: string;
  title: string;
  description: string;
  flipped?: boolean;
  tags?: string;
}

const Card: React.FC<CardProps> = ({
  id,
  image,
  title,
  description,
  tags,
  flipped,
}) => {
  const navigate = useNavigate();
  const tagList = tags ? tags.split(",").map((tag) => tag.trim()) : [];

  const handleCardClick = () => {
    navigate(`/ventures/${id}`);
  };

  return (
    <div
      onClick={handleCardClick}
      className={`bg-white p-[1.6rem] rounded-[0.5rem] overflow-hidden flex flex-col cursor-pointer ${
        flipped ? "flex-col-reverse" : "flex-col"
      }`}
    >
      <div
        className={`relative h-[40rem] rounded-[0.5rem] ${
          flipped ? "" : "mb-[1.6rem]"
        }`}
      >
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover rounded-[0.5rem]"
        />

        <div className="absolute bottom-4 left-4 flex flex-col max-w-full">
          {tagList.length > 0 && (
            <div className="flex flex-wrap gap-[0.8rem] max-w-full">
              {tagList.map((tag, index) => (
                <span
                  key={index}
                  className="bg-white text-black text-[1.2rem] py-[0.4rem] px-[0.8rem] rounded-[0.5rem] whitespace-nowrap shadow-sm border border-gray-200"
                  style={{
                    maxWidth: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "inline-block",
                  }}
                >
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className={`flex flex-col ${flipped ? "mb-[1.6rem]" : ""}`}>
        <h3 className="font-semibold text-[1.8rem] mb-[0.8rem]">{title}</h3>
        <p className="text-[1.4rem]">{description}</p>
      </div>
    </div>
  );
};

export default Card;
